import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Table, Container, Row, Col, Badge } from "reactstrap";
import { userReferralListApi } from "./_requests";
import { formatDate } from "../../helpers/FunctionHelpers";

interface Referral {
  id: number;
  user_id: number;
  referral_applied_user_id: number;
  referral_code: string;
  product_id: number | null;
  subscription_id: number;
  no_of_delivery_days: number;
  is_active: boolean;
  is_expried: boolean;
  start_date: string;
  end_date: string;
  used_count: number;
  status: string;
  created_at: string;
  updated_at: string;
  referrer: {
    id: number;
    name: string;
  };
  referredUser: {
    id: number;
    name: string;
  };
  subscription: {
    id: number;
    name: string;
    referral: {
      id: number;
      subscription_id: number;
      no_of_delivery_days: number;
      no_of_times_used: number;
      enable_disable: boolean;
    };
  };
}

const UserReferralList = () => {
  const { id } = useParams<{ id: string }>();
  const [referrals, setReferrals] = useState<Referral[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchReferrals = async () => {
      try {
        setLoading(true);
        const data = { user_id: id }
        const response = await userReferralListApi(data);
        console.log("response userReferralListApi", response)
        if (response.status && response.data) {
          setReferrals(response.data);
        }
      } catch (error) {
        console.error("Error fetching referrals:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchReferrals();
  }, [id]);

  const getStatusBadge = (status: string) => {
    switch (status) {
      case "1":
        return <Badge color="success">Active</Badge>;
      case "0":
        return <Badge color="danger">Inactive</Badge>;
      default:
        return <Badge color="secondary">Unknown</Badge>;
    }
  };

  return (
    <div className="">
      <Container fluid>

        <Row>
          <Col lg={12}>
          <h2>{}</h2>
            {loading ? (
              <div className="text-center">Loading...</div>
            ) : referrals.length > 0 ? (
              <Table bordered responsive>
                <thead className="text-primary fw-bold">
                  <tr>
                    <th>#</th>
                    <th>Referral Code</th>
                    <th>Referrer</th>
                    <th>Referred User</th>
                    <th>Subscription</th>
                    <th>Delivery Days</th>
                    <th>Status</th>
                    <th>Dates</th>
                    <th>Usage</th>
                  </tr>
                </thead>
                <tbody>
                  {referrals.map((referral, index) => (
                    <tr key={referral.id}>
                      <td>{index + 1}</td>
                      <td>
                        <strong>{referral.referral_code}</strong>
                      </td>
                      <td>{referral.referrer.name}</td>
                      <td>{referral.referredUser.name}</td>
                      <td>{referral.subscription.name}</td>
                      <td>{referral.no_of_delivery_days}</td>
                      <td>
                        {getStatusBadge(referral.status)}
                        <br />
                        {referral.is_active ? (
                          <Badge color="success">Active</Badge>
                        ) : (
                          <Badge color="danger">Inactive</Badge>
                        )}
                        {referral.is_expried && (
                          <Badge color="warning" className="ms-1">
                            Expired
                          </Badge>
                        )}
                      </td>
                      <td>
                        <div>
                          <strong>Start:</strong> {formatDate(referral.start_date)}
                        </div>
                        <div>
                          <strong>End:</strong> {formatDate(referral.end_date)}
                        </div>
                      </td>
                      <td>
                        <div>
                          <strong>Used:</strong> {referral.used_count} time(s)
                        </div>
                        <div>
                          <strong>Max:</strong> {referral.subscription.referral.no_of_times_used}
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            ) : (
              <div className="text-center fw-bold py-5">
                No referral data found
              </div>
            )}
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default UserReferralList;